'use strict';

(function () {
    const corporateNameInputWrapperElement = document.getElementById("corporateNameInputWrapper");
    const legalPersonDisclaimerElement = document.getElementById("legalPersonDisclaimer");
    const titleInputWrapperElement = document.getElementById("titleInputWrapper");

    if (corporateNameInputWrapperElement && legalPersonDisclaimerElement) {
        const input = corporateNameInputWrapperElement.querySelector('input');

        const moralPersonButton = document.getElementById("mp");
        if (moralPersonButton) {
            moralPersonButton.addEventListener("change", function () {
                corporateNameInputWrapperElement.style.display = '';
                legalPersonDisclaimerElement.style.display = '';
                input.required = true;
            });
        }

        const physicalPersonButton = document.getElementById("pp");
        if (physicalPersonButton) {
            physicalPersonButton.addEventListener("change", function () {
                corporateNameInputWrapperElement.style.display = 'none';
                legalPersonDisclaimerElement.style.display = 'none';
                input.required = false;
            });
        }
    }

    if (titleInputWrapperElement) {
        const select = titleInputWrapperElement.querySelector('select');

        const moralPersonButton = document.getElementById("mp");
        if (moralPersonButton) {
            moralPersonButton.addEventListener("change", function () {
                titleInputWrapperElement.style.display = 'none';
                select.required = false;
            });
        }

        const physicalPersonButton = document.getElementById("pp");
        if (physicalPersonButton) {
            physicalPersonButton.addEventListener("change", function () {
                titleInputWrapperElement.style.display = '';
                select.required = true;
            });
        }
    }
}());
